import { Link } from '@ipfabric/ui-components/Link/Link';
import type { FC, ReactNode } from 'react';
import { BreakdownLegend } from './BreakdownLegend';
import type { BreakdownItem } from './licenseBreakdownData';

export type BreakdownSectionProps = {
  title: string;
  /** Sibling tab showing the rows behind the chart. */
  detailPath: string;
  legend: BreakdownItem[];
  children: ReactNode;
};

/** Heading with a link to the detailed table, the chart, and the chart's legend below it. */
export const BreakdownSection: FC<BreakdownSectionProps> = ({
  title,
  detailPath,
  legend,
  children,
}) => (
  // `min-w-0`: a grid item defaults to `min-width: auto`, which would let the chart canvas hold this
  // column open at its previous width instead of shrinking with it.
  <div className='flex min-w-0 flex-col gap'>
    <div className='flex items-baseline justify-between gap'>
      <h3 className='m-none font-semibold text-default text-level-6'>
        {title}
      </h3>
      <Link to={detailPath} icon='fa-chevron-right' iconPosition='end'>
        More detail
      </Link>
    </div>
    {children}
    <BreakdownLegend items={legend} />
  </div>
);
